import { connect } from 'react-redux'
import { actions } from '@bt-react/store'
import AttachmentsForm from './AttachmentsForm'

const mapStateToProps = (state: any, props: any) => {

    return {
        status: state.resources && state.resources.status,
        activeResource: state.resources && state.resources.activeResource,
        setting: state.resources && state.resources.setting && state.resources.setting.data
    }

}

const mapDispatchToProps = (dispatch: any) => ({
    submitAttachmentForm: (formData: any, userTimezone) =>
        dispatch(actions.resource.addAttachments(formData, userTimezone)),
    setView: (view: string) =>
        dispatch(actions.resource.setAttachmentView(view)),
    fetchResourceSetting: () => dispatch(actions.resource.fetchResourceSetting())
})

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentsForm)
